import { render, staticRenderFns } from "./IdentifyAccountManage.vue?vue&type=template&id=c799cb6c&scoped=true&"
import script from "./IdentifyAccountManage.vue?vue&type=script&lang=js&"
export * from "./IdentifyAccountManage.vue?vue&type=script&lang=js&"
import style0 from "./IdentifyAccountManage.vue?vue&type=style&index=0&id=c799cb6c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c799cb6c",
  null
  
)

export default component.exports